import React, { useEffect, useState } from "react";
import {
  Spin,
  Select,
  DatePicker,
  Form,
  Button,
  Table,
  Input,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FilterFilled, SearchOutlined } from "@ant-design/icons";
import { ReadCookie } from "../../utils/readCookie";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo.png";
import "../Distributor/Distributor.css";
import { useRef } from "react";
import { CSVLink } from "react-csv";
import { TabTitle } from "../../utils/GeneralFunction";
import { getFactor } from "../../redux/actions/factor.action";
import { getNetShipStyleWise } from "../../redux/actions/netShipStyleWise.action";
import { getGender } from "../../redux/actions/gender.action";
import numeral from "numeral";
import { getRegion } from "../../redux/actions/region.action";
import { loadSalePerson } from "../../redux/actions/salePerson/salePersonForm.action";
import { getCustomerType } from "../../redux/actions/customerType.action";

const { Option } = Select;

const NetShippedStyleWise = ({ token }) => {
  TabTitle("Net Shipped");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    netShipStyleWise,
    factor,
    gender,
    customerTypes,
    region,
    salePersonForm
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [intransitList, setIntransitList] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const initialDate = moment().add(2, 'year').endOf('year');



  const onFinish = async (e) => {
    setLoading(true);
    await form.validateFields().then((data) => {

      dispatch(getNetShipStyleWise(token, data)).then((res) => {

        setLoading(false);
        setIntransitList(res?.payload?.data);
        downloadExcelFileData(res?.payload?.data);
      });
    });
  };

  useEffect(() => {
    dispatch(getFactor(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getRegion(token, menuId));
    dispatch(getCustomerType(token));
    dispatch(loadSalePerson(token));

  }, [dispatch, menuId, token]);

  const handlePrint = () => {
    window.print();
  };

  const colums = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 40,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "Customer ID",
      dataIndex: "customer_id",
      key: "customer_id",
      // align: "right",
      sorter: (a, b) => {
        return a.customer_id.replace(",", "") - b.customer_id.replace(",", "");
      },
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
        filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.customer_name !== null) {
          return record.customer_name
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.customer_name !== null) & (b.customer_name !== null)) {
          return a.customer_name.localeCompare(b.customer_name);
        }
      },
    },
    {
      title: "Ship Qty",
      dataIndex: "ship_quantity",
      key: "ship_quantity",
      align: "right",
      sorter: (a, b) => {
        return a.ship_quantity.replace(",", "") - b.ship_quantity.replace(",", "");
      },
    },
    {
      title: "Ship Amount",
      dataIndex: "ship_amount",
      key: "ship_amount",
      render: (text, record) => {
        return (
          <>
            ${(record.ship_amount)}
          </>
        );
      },
      align: "right",
      sorter: (a, b) => {
        return a.ship_amount.replace(",", "") - b.ship_amount.replace(",", "");
      },
    },
    {
      title: "Return Qty",
      dataIndex: "return_quantity",
      key: "return_quantity",
      align: "right",
      sorter: (a, b) => {
        return a.return_quantity.replace(",", "") - b.return_quantity.replace(",", "");
      },
    },
    {
      title: "Return Amount",
      dataIndex: "return_amount",
      key: "return_amount",
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${(record.return_amount)}
          </>
        );
      },
      sorter: (a, b) => {
        return a.return_amount.replace(",", "") - b.return_amount.replace(",", "");
      },
    },
    {
      title: "Net Qty",
      dataIndex: "net_quantity",
      key: "net_quantity",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {numeral(text).format('0,0')}
          </>
        );
      },
      sorter: (a, b) => {
        return a.net_quantity.replace(",", "") - b.net_quantity.replace(",", "");
      },
    },
    {
      title: "Net Amount",
      dataIndex: "net_amount",
      key: "net_amount",
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${numeral(record.net_amount).format("0,00,0.00")}
          </>
        );
      },
      sorter: (a, b) => {
        return a.net_amount.replace(",", "") - b.net_amount.replace(",", "");
      },
    },
    {
      title: "Status",
      dataIndex: "factor_name",
      key: "factor_name",
      align: "center",
      sorter: (a, b) => {
        if ((a.factor_name !== null) & (b.factor_name !== null)) {
          return a.factor_name.localeCompare(b.factor_name);
        }
      },
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      align: "center",
      sorter: (a, b) => {
        if ((a.gender_name !== null) & (b.gender_name !== null)) {
          return a.gender_name.localeCompare(b.gender_name);
        }
      },
    },
    {
      title: "Customer Type",
      dataIndex: "customer_type_name",
      key: "customer_type_name",
      align: "center",
      sorter: (a, b) => {
        if ((a.customer_type_name !== null) & (b.customer_type_name !== null)) {
          return a.customer_type_name.localeCompare(b.customer_type_name);
        }
      },
    },
    {
      title: "Region",
      dataIndex: "region_name",
      key: "region_name",
      align: "center",
      sorter: (a, b) => {
        if ((a.region_name !== null) & (b.region_name !== null)) {
          return a.region_name.localeCompare(b.region_name);
        }
      },
    },
    {
      title: "SalesPerson",
      dataIndex: "salesperson_name",
      key: "salesperson_name",
      align: "center",
      sorter: (a, b) => {
        if ((a.salesperson_name !== null) & (b.salesperson_name !== null)) {
          return a.salesperson_name.localeCompare(b.salesperson_name);
        }
      },
    },
    {
      title: "Priority",
      dataIndex: "priority_name",
      key: "priority_name",
      align: "center",
      sorter: (a, b) => {
        if ((a.priority_name !== null) & (b.priority_name !== null)) {
          return a.priority_name.localeCompare(b.priority_name);
        }
      },
    },
  ];


  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "Customer ID": v.customer_id,
          "Customer Name": v.customer_name,
          "Ship Qty": v.ship_quantity,
          "Ship Amount": v.ship_amount,
          "Return Qty": v.return_quantity,
          "Return Amount": v.return_amount,
          "Net Qty": numeral(v.net_quantity).format('0,0'),
          "Net Amount": numeral(v.net_amount).format("0,00,0.00"),
          "Status": v.factor_name,
          "Gender": v.gender_name,
          "Customer Type": v.customer_type_name,
          "Region": v.region_name,
          "SalesPerson": v.salesperson_name,
          "Priority": v.priority_name,
        };
      })
    );
  }


  const totalQuantity = () => {
    let sumQty = intransitList.reduce(function (previousValue, currentValue) {
      return previousValue += Number(currentValue.net_quantity);
    }, 0);
    return sumQty;
  }

  const totalSum = () => {
    let sumAmount = intransitList.reduce(function (previousValue, currentValue) {
      return previousValue += Number(currentValue.net_amount);
    }, 0);
    return sumAmount;
  }



  return (
    <div className="header_class business_header_oms intransit">
      <div className="row justify-content-between business_class_oms distributor">
        <div className="col-3 d-flex align-items-start box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class">
                <CSVLink
                  filename={"Net-Shipped-Customer-Wise.csv"}
                  data={excelData}
                  onClick={() => { }}
                >
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}


                    style={{ borderWidth: "0px", height: "14px" }}
                  />
                </CSVLink>
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Net Shipped Customer Wise
              <br />
              Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p>
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="business_class_oms mb-2 distributor">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-1" />
              <div className="row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width30" htmlFor="">
                      From
                    </label>
                    <div className="w-100">
                      <Form.Item
                        name="from_date"
                        className="full_date"
                        initialValue={moment().startOf("year")}
                      >
                        <DatePicker
                          size="small"
                          format={"MM-DD-YYYY"}
                          defaultValue={moment().format("MM-DD-YYYY")}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width30" htmlFor="">
                      To
                    </label>
                    <div className="w-100">
                      <Form.Item
                        name="to_date"
                        className="full_date"
                        initialValue={initialDate}
                      >
                        <DatePicker
                          size="small"
                          format={"MM-DD-YYYY"}
                          defaultValue={moment().format("MM-DD-YYYY")}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width40" htmlFor="">
                      Factor Type
                    </label>
                    <div className="w-100">
                      <Form.Item

                        name="paymentClass"
                        className="full_date"
                        initialValue={"All"}
                      >
                        <Select
                          size="small"
                          autoComplete={"nope"}
                          filterOption={(input, option) => option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0}
                          showSearch
                          loading={factor.loading}
                        >
                          <Option value={null}>All</Option>

                          {factor?.payload?.data.map(
                            (item) => {
                              return (
                                <Select.Option
                                  key={item.factor_id}

                                  value={item.factor_id}
                                >
                                  {item.factor_name}
                                </Select.Option>
                              );
                            }
                          )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width40" htmlFor="">
                      Gender
                    </label>
                    <div className="w-100">
                      <Form.Item

                        name="gender_id"
                        className="full_date"
                        initialValue={"All"}
                      >
                        <Select
                          size="small"
                          autoComplete={"nope"}
                          filterOption={(input, option) =>
                            (option?.children?.toString().toLowerCase().includes(input?.toLowerCase()))
                          }
                          showSearch
                          loading={gender.loading}
                        >
                          <Option value={null}>All</Option>

                          {gender?.payload?.data.map((val, id) => (
                            <Option value={val.gender_id} key={val.gender_id}>
                              {" "}
                              {val.gender_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width30" htmlFor="">
                      C. Type
                    </label>
                    <div className="w-100">
                      <Form.Item

                        name="customer_type"
                        className="full_date"
                        initialValue={"All"}
                      >
                        <Select
                          size="small"
                          autoComplete={"nope"}
                          filterOption={(input, option) =>
                            (option?.children?.toString().toLowerCase().includes(input?.toLowerCase()))
                          }
                          showSearch
                          loading={customerTypes.loading}
                        >
                          <Option value={null}>All</Option>

                          {customerTypes?.payload?.data.map((item) => {
                            return <Option key={item.customer_type_id} value={item?.customer_type_id}>{item?.customer_type_name}</Option>
                          })
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width30" htmlFor="">
                      Region
                    </label>
                    <div className="w-100">
                      <Form.Item

                        name="region_id"
                        className="full_date"
                        initialValue={"All"}
                      >
                        <Select
                          size="small"
                          autoComplete={"nope"}
                          filterOption={(input, option) =>
                            (option?.children?.toString().toLowerCase().includes(input?.toLowerCase()))
                          }
                          showSearch
                          loading={region.loading}
                        >
                          <Option value={null}>All</Option>

                          {region &&
                            region?.payload?.data.map((region, i) => {
                              return (
                                <Option
                                  key={region.region_id}
                                  value={region.region_id}
                                >
                                  {region.region_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width40" htmlFor="">
                      SalesPerson
                    </label>
                    <div className="w-100">
                      <Form.Item

                        name="salesperson_id"
                        className="full_date"
                        initialValue={"All"}
                      >
                        <Select
                          size="small"
                          autoComplete={"nope"}
                          filterOption={(input, option) =>
                            (option?.children?.toString().toLowerCase().includes(input?.toLowerCase()))
                          }
                          showSearch
                          loading={salePersonForm.loading}
                        >
                          <Option value={null}>All</Option>

                          {
                            salePersonForm?.payload?.data.map((val, index) => {
                              return (
                                <Option key={index} value={val.sales_person_id}>{val.salesperson_name}</Option>
                              )
                            })
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width40" htmlFor="">
                      Priority
                    </label>
                    <div className="w-100">
                      <Form.Item

                        name="priority_id"
                        className="full_date"
                        initialValue={"All"}
                      >
                        <Select
                          size="small"
                          autoComplete={"nope"}
                          // filterOption={(input, option) =>
                          //   (option?.children?.toString().toLowerCase().includes(input?.toLowerCase()))
                          // }
                          showSearch
                        >
                          <Option value={null}>All</Option>
                          <Option value={1}>High</Option>
                          <Option value={2}>Normal</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div style={{ marginTop: "4px", display: "flex", justifyContent: "end" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="submit-btn-btm m-0"
                    >
                      Generate
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div

        className="table_content international_order"
        style={{ maxWidth: "1480px" }}
      >
        <div>
          {netShipStyleWise?.payload?.data !== undefined ? (
            netShipStyleWise?.payload?.data.length > 0 ? (
              <Table
                className="border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style even-tr-style border omsTable width-fabric-stock-table"
                ref={tableRef}
                size="small"
                bordered={false}
                type="company"
                headerClassName="abc"
                dataSource={intransitList}
                columns={colums}
                loading={netShipStyleWise.loading}
                scroll={{ x: "max-content" }}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: 100,
                  pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                }}
                summary={(pageData) => {

                  let ship_Qty = pageData.reduce(function (
                    previousValue,
                    currentValue
                  ) {
                    return (previousValue +=
                      parseFloat(currentValue.ship_quantity.replace(",", ""))
                    );
                  },
                    0);
                  let ship_Amount = pageData.reduce(function (
                    previousValue,
                    currentValue
                  ) {
                    return (previousValue += parseFloat(
                      currentValue.ship_amount.replace(",", "")
                    ));
                  },
                    0);
                  let return_Qty = pageData.reduce(function (
                    previousValue,
                    currentValue
                  ) {
                    return (previousValue += parseFloat(
                      currentValue.return_quantity.replace(",", "")
                    ));
                  },
                    0);
                  let return_Amount = pageData.reduce(function (
                    previousValue,
                    currentValue
                  ) {
                    return (previousValue += parseFloat(
                      currentValue.return_amount.replace(",", "")
                    ));
                  },
                    0);
                  let net_Qty = pageData.reduce(function (
                    previousValue,
                    currentValue
                  ) {
                    return (previousValue += parseFloat(
                      currentValue.net_quantity.replace(",", "")
                    ));
                  },
                    0);
                  let net_Amount = pageData.reduce(function (
                    previousValue,
                    currentValue
                  ) {
                    return (previousValue += parseFloat(
                      currentValue.net_amount.replace(",", "")
                    ));
                  },
                    0);



                  return (
                    <>
                      <Table.Summary.Row>
                        {/* <Table.Summary.Cell colSpan={3} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : ${numeral(totalSum()).format("0,0.00")} */}
                        {/* </Table.Summary.Cell> */}
                        <Table.Summary.Cell colSpan={3}>Total Quantity :  {numeral(totalQuantity()).format("0,00,0")}
                        </Table.Summary.Cell>
                        {/* <Table.Summary.Cell></Table.Summary.Cell> */}
                        {/* <Table.Summary.Cell></Table.Summary.Cell> */}
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            {ship_Qty.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {ship_Amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            {return_Qty.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {return_Amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            {net_Qty.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {net_Amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                      <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={2} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : $ {numeral(totalSum()).format("0,0.00")}
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
            ) : (
              <div className="no-Data">
                {/* {} */}
                <h1>No Data</h1>
              </div>
            )
          ) : (
            loading && (
              <div className="loader" style={{ marginTop: "20px" }}>
                <Spin size="medium" />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default NetShippedStyleWise;
